import ApiCore from '../utilities/Core';

// Login API

const url = 'chat';
const plural = 'chat';
const single = 'chat';

export const apiChat = new ApiCore({
    getAll: false,
    getSingle: false,
    post: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
    plural: plural,
    single: single,
});
